/* Replace by PHP at generation time */
(function() {
    document.addEventListener('DOMContentLoaded', function() {
        /** Set the language link href */
        const vbLinkToAltLang = document.getElementById("switch_language");
        if (vbLinkToAltLang) {
            vbLinkToAltLang.href = getAlternateLangUrl();
        } else {
            console.error('Element with ID "switch_language" not found.');
        }

        /** Set the browser link to the desktop page and
         * Adds an event listener for a click on the element id "to_desktop", that launches a function called "to_desktop".
         * This will redirect the user to the Desktop version, and launch the function that updates the cookie 
         */
        const vbLinkToDesktop = document.getElementById("link_to_desktop");
        if (vbLinkToDesktop) {
            const vbMobileUrl = window.location.href;
            vbLinkToDesktop.href = vbMobileUrl.split("/mobile/").join("/");
            vbLinkToDesktop.addEventListener('click', resetPhoneCookie);
        }else {
            console.error('Element with ID "link_to_desktop" not found.');
        }

        /**
         * Update the cookie to indicate that the user is switching from mobile to desktop view,
         * and redirects the user to the corresponding desktop page. Note: do not set HttpOnly (inacessible by JS).
         */
        function resetPhoneCookie() {
            document.cookie = "phone=0; path=/; Secure";
        }

        /**
         * Retrieves the alternate language URL based on the current language.
         * @returns {string} The pathname of the alternate language URL.
         */
        function getAlternateLangUrl() {
            /** Get the content of the "lang" attribute of the "html" tag, 
             * and sets the links to switch the language
             */
            const vbLang = document.documentElement.lang;
            let vbUrl = new URL(window.location.href);
            const vbPath = vbUrl.pathname;
            const vbQuery = vbUrl.search;
            let vbNewPath = '';
            let vbAltHomePge = window.location.origin;
            let vbLinkTag = '';

            if (vbLang == 'fr') {
                vbAltHomePge += '/en/mobile/';
                switch (true) {
                    case vbPath.startsWith('/mobile/commande/votre-panier/'):
                        vbNewPath = vbPath.replace('/commande/votre-panier', '/en/order/your-basket');
                        break;
                    case vbPath.startsWith('/mobile/commande/votre-commande/'):
                        vbNewPath = vbPath.replace('/mobile/commande/votre-commande', '/en/order/your-order');
                        break;
                    case vbPath.startsWith('/mobile/commande/votre-confirmation/'):
                        vbNewPath = vbPath.replace('/mobile/commande/votre-confirmation', '/en/order/your-confirmation');
                        break;
                    default:
                        /* For the other urls, fetch the alternate hreflang */
                        vbLinkTag = document.querySelector('link[rel="alternate"][hreflang="en"]');
                        vbUrl = vbLinkTag ? new URL(vbLinkTag.href) : new URL(vbAltHomePge, window.location.origin);
                        vbNewPath = vbUrl.pathname;
                }
            } else {
                vbAltHomePge += '/mobile/';
                switch (true) {
                    case vbPath.startsWith('/en/mobile/order/your-basket/'):
                        vbNewPath = vbPath.replace('/en/mobile/order/your-basket', '/mobile/commande/votre-panier');
                        break;
                    case vbPath.startsWith('/en/mobile/order/your-order/'):
                        vbNewPath = vbPath.replace('/en/mobile/order/your-order', '/mobile/commande/votre-commande');
                        break;
                    case vbPath.startsWith('/en/order/your-confirmation/'):
                        vbNewPath = vbPath.replace('/en/mobile/order/your-confirmation', '/mobile/commande/votre-confirmation');
                        break;
                    default:
                        /* For the other urls, fetch the alternate hreflang */
                        vbLinkTag = document.querySelector('link[rel="alternate"][hreflang="fr"]');
                        vbUrl = vbLinkTag ? new URL(vbLinkTag.href) : new URL(vbAltHomePge, window.location.origin);
                        vbNewPath = vbUrl.pathname;
                }
            }
            
            return vbNewPath + vbQuery;
        }
    });
})();